export const UPDATE_FULL_POST_STYLE = 'UPDATE_FULL_POST_STYLE';
//# sourceMappingURL=editor-events.js.map